import { z } from 'zod/v4';

// The roster's two filter option sets. `officialName` is nullable because the
// company behind a webshop may have been removed (and its name with it); the
// legacy schema called it a required string.
export const AdminWebshopConstantsCompanySchema = z.object({
  id: z.string(),
  officialName: z.string().nullable(),
});

export type AdminWebshopConstantsCompany = z.infer<
  typeof AdminWebshopConstantsCompanySchema
>;

export const AdminWebshopConstantsResponseSchema = z.object({
  companies: z.array(AdminWebshopConstantsCompanySchema),
  shopPlatforms: z.array(z.string()),
});

export type AdminWebshopConstantsResponse = z.infer<
  typeof AdminWebshopConstantsResponseSchema
>;
